// Single source of truth for "what roles exist and what kind are they."
// Supersedes the dead/misspelled role-list constants this replaces:
//   - src/utils/rbac.js: USER_ROLES (dead export), EXTRENAL_USERS (misspelled, dead export) - deleted
//   - src/constants/index.js: EXTERNAL_USER_ROLES - was missing ExternalNE1ReadOnly (fixed); still has
//     one real consumer (useExternalUserRedirect.js), so kept rather than deleted.

export const ROLES = [
  "MedlineAdministrator",
  "MedlineStandardUser",
  "MedlineSupport",
  "ExternalAdministrator",
  "ExternalStandardUser",
  "ExternalNE1WoundExpert",
  "ExternalNE1Review",
  "ExternalNE1Assesment",
  "ExternalNE1ReadOnly",
] as const;

export type Role = (typeof ROLES)[number];

interface RoleMetadata {
  /** Medline-internal staff role vs. a customer-facing external role. */
  isExternal: boolean;
  /** Grants broad administrative capability (used by basicInfo.js/moreInfo.js's isAdministrator() checks). */
  isAdministrator: boolean;
}

export const ROLE_METADATA: Record<Role, RoleMetadata> = {
  MedlineAdministrator: { isExternal: false, isAdministrator: true },
  MedlineStandardUser: { isExternal: false, isAdministrator: false },
  MedlineSupport: { isExternal: false, isAdministrator: false },
  ExternalAdministrator: { isExternal: true, isAdministrator: true },
  ExternalStandardUser: { isExternal: true, isAdministrator: false },
  ExternalNE1WoundExpert: { isExternal: true, isAdministrator: false },
  ExternalNE1Review: { isExternal: true, isAdministrator: false },
  ExternalNE1Assesment: { isExternal: true, isAdministrator: false },
  ExternalNE1ReadOnly: { isExternal: true, isAdministrator: false },
};

export const isExternalRole = (role?: string | null): boolean =>
  !!role && !!ROLE_METADATA[role as Role]?.isExternal;

export const isAdministratorRole = (role?: string | null): boolean =>
  !!role && !!ROLE_METADATA[role as Role]?.isAdministrator;
